import { ActionReducerMap } from '@ngrx/store';
import { authReducer,tokenReducer} from './auth/auth.reducer';
import { AuthState, TokenState } from "./auth/auth.state";
import { AccountState } from "./account/account.state";
import { accountReducer } from "./account/account.reducer";
import { GroupState } from "./group/group.state";
import {groupReducer} from "./group/group.reducer";
import { DeviceState } from './device/device.state';
import { deviceReducer } from "./device/device.reducer";
import { RestrictionState } from './restriction/restriction.state';
import { restrictionReducer } from './restriction/restriction.reducer';
import { ChildDeactivationState } from './child-deactivation/child-deactivation.state';
import { PupilLinkState } from './pupil-link/pupil-link.state';
import { PupilDuplicateState } from './pupil-duplicate/pupil-duplicate.state';
import { WondeSyncState } from './wonde-sync/wonde-sync.state';
import { childDeactivationReducer } from './child-deactivation/child-deactivation.reducer';
import { pupilLinkReducer } from './pupil-link/pupil-link.reducer';
import { pupilDuplicateReducer } from './pupil-duplicate/pupil-duplicate.reducer';
import { wondeSyncReducer } from './wonde-sync/wonde-sync.reducer';
import { SchoolCalendarState } from './school-calendar/school-calendar.state';
import { schoolCalendarReducer } from './school-calendar/school-calendar.reducer';

export interface AppState {
    userAuthentication: AuthState;
    userToken: TokenState
    account: AccountState;
    group: GroupState;
    device: DeviceState;
    restriction: RestrictionState;
    pupilLink: PupilLinkState;
    pupilDuplicate: PupilDuplicateState;
    wondeSync: WondeSyncState;
    childDeactivation: ChildDeactivationState;
    schoolCalendar: SchoolCalendarState;
    // add more slices as needed
}

export const appReducer: ActionReducerMap<AppState> = {
  userAuthentication: authReducer,
  userToken: tokenReducer,
  account: accountReducer,
  group: groupReducer,
  device: deviceReducer,
  restriction: restrictionReducer,
  pupilLink: pupilLinkReducer,
  pupilDuplicate: pupilDuplicateReducer,
  wondeSync: wondeSyncReducer,
  childDeactivation: childDeactivationReducer,
  schoolCalendar: schoolCalendarReducer
};